import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './responsive.css';
import App from './App.jsx';
import PressPage from './PressPage';
import reportWebVitals from './reportWebVitals';

const path = window.location.pathname;
const pressMatch = path.match(/^\/@?([^/]+)\/press$/);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(pressMatch ? <PressPage handle={pressMatch[1]} /> : <App />);
reportWebVitals();
